import React,{useState} from 'react';
import SectionContent from "./SectionContent";

function HomeContent(props) {
    const [categories,setCategories] = useState([
        {
            name: 'جدیدترین ها',
            type: 'album',
            id: 1,
            products : [
                {name:'نسخه1', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه2', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه3', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه4', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه5', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه6', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه7', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه8', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه9', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه10', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه11', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه12', artist:'هیپاپولوژیست',id : 1} ,
            ]
        },
        {
            name: 'ویژه های نمانو',
            type: 'album',
            id: 2,
            products : [
                {name:'نسخه1', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه2', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه3', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه4', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه5', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه6', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه7', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه8', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه9', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه10', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه11', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه12', artist:'هیپاپولوژیست',id : 1} ,
            ]
        },
        {
            name: 'موسیقی',
            id: 3,
            type: 'album',
            products : [
                {name:'نسخه1', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه2', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه3', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه4', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه5', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه6', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه7', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه8', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه9', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه10', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه11', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه12', artist:'هیپاپولوژیست',id : 1} ,
            ]
        },
        {
            name: 'کتاب صوتی',
            type: 'audio-book',
            id: 4,
            products : [
                {name:'نسخه1', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه2', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه3', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه4', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه5', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه6', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه7', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه8', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه9', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه10', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه11', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه12', artist:'هیپاپولوژیست',id : 1} ,
            ]
        },
        {
            name: 'پادکست',
            type: 'podcast',
            id: 5,
            products : [
                {name:'نسخه1', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه2', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه3', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه4', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه5', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه6', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه7', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه8', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه9', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه10', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه11', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه12', artist:'هیپاپولوژیست',id : 1} ,
            ]
        },
        {
            name: 'پلی لیست',
            id: 6,
            type: 'play-list',
            products : [
                {name:'نسخه1', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه2', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه3', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه4', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه5', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه6', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه7', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه8', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه9', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه10', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه11', artist:'هیپاپولوژیست',id : 1} ,
                {name:'نسخه12', artist:'هیپاپولوژیست',id : 1} ,
            ]
        },
    ])
    return (
        <div className="">
            <div className=''>
                {categories?.map((categori,index) =>
                    <SectionContent title={categori.name} products={categori.products} type={categori.type} id={categori.id}/>
                )}
            </div>
        </div>

    );
}

export default HomeContent;